
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup/ram-rampage",
      function () {
        return require("private-next-pages/wheels/pickup/ram-rampage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup/ram-rampage"])
      });
    }
  